import {
  ApprovalWorkflowEditor,
  SaveAndCancel,
  StickyActionsHeader,
} from "@/components";
import { PageWrapper } from "@/components/PageWrapper";
import { CONTENT_WIDTH, FormType, GUTTER_SIZE } from "@/enums";
import { routes } from "@/helpers";
import { useFormPropertyValueLookupProvider } from "@/providers";
import {
  useGetAllNotificationGroupsQuery,
  useSaveApprovalWorkflowMutation,
} from "@/services";
import { Card, Col, Form, Row } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const DEFAULT_DISTRIBUTION_GROUPS = [
  "vpinprojectid@milwaukeetool.com",
  "vpinprojectidnpd@milwaukeetool.com",
];

const AddApprovalWorkflow = () => {
  const intl = useIntl();

  const [newApprovalWorkflow, setNewApprovalWorkflow] = useState({
    name: null,
    projectTypeIds: [],
    approvers: null,
    notificationGroups: undefined,
  });
  const navigate = useNavigate();
  const [projectTypes, setProjectTypes] = useState([]);
  const [isValidForm, setIsValidForm] = useState(false);
  const { getProperty } = useFormPropertyValueLookupProvider();

  const { data: notificationGroups } = useGetAllNotificationGroupsQuery();

  const [saveApprovalWorkflow] = useSaveApprovalWorkflowMutation();

  useEffect(() => {
    setNewApprovalWorkflow((value) => ({
      ...value,
      notificationGroups: notificationGroups
        ?.filter(({ email }) =>
          DEFAULT_DISTRIBUTION_GROUPS.includes(email.toLowerCase())
        )
        .map(({ id }) => id),
    }));
  }, [notificationGroups]);

  useEffect(() => {
    const projectTypes = getProperty(FormType.Intake, "projectType");

    if (!projectTypes) return;

    let values = [];
    values = Object.keys(projectTypes).map((id) => ({
      value: id,
      label: projectTypes[id].fallback,
    }));
    setProjectTypes(values);
  }, [getProperty, intl]);

  const handleSaveButtonClick = () => {
    saveApprovalWorkflow(newApprovalWorkflow)
      .unwrap()
      .then(({ id }) => {
        toast.success(intl.formatMessage({ id: "general.toastChangesSaved" }));
        navigate(routes.admin.approvalWorkFlows.get(id));
      })
      .catch(() =>
        toast.error(
          intl.formatMessage({ id: "general.toastSomethingWentWrong" })
        )
      );
  };

  if (!newApprovalWorkflow.notificationGroups) return null;

  return (
    <PageWrapper
      pageTitle={intl.formatMessage({ id: "approvalWorkFlows.addTitle" })}
      backButtonRoute={routes.admin.approvalWorkFlows.list}
      pageActions={
        <StickyActionsHeader
          rightChildren={
            <SaveAndCancel
              pageName="add-approval-workflow"
              saveOnClick={handleSaveButtonClick}
              cancelOnClick={() =>
                navigate(routes.admin.approvalWorkFlows.list)
              }
              saveDisabled={!isValidForm}
            />
          }
        />
      }
    >
      <Card>
        <Form layout="vertical">
          <Row gutter={GUTTER_SIZE.large}>
            <Col span={CONTENT_WIDTH.half}>
              <ApprovalWorkflowEditor
                projectTypes={projectTypes}
                onSetApprovalWorkFlow={setNewApprovalWorkflow}
                approvalWorkflow={newApprovalWorkflow}
                setIsValidForm={setIsValidForm}
              />
            </Col>
          </Row>
        </Form>
      </Card>
    </PageWrapper>
  );
};

export default AddApprovalWorkflow;
